import { apolloClient } from "js/apollo/apollo-client";

// queries/mutations
import {
    FETCH_BATCHES,
    FETCH_PHOTO_COUNTS_FOR_BATCHES,
    FETCH_UPLOADS_IDS_IN_BATCHES
} from "frontend/components/fort/mod/photos/queries.js";
import { ASSIGN_BATCH_TO_MOD } from "frontend/components/fort/mod/photos/mutations.js";

/*---------------------------
| Queries
---------------------------*/
export const fetchBatches = async (variables, limit, offset) => {
    const { data } = await apolloClient.query({
        query: FETCH_BATCHES,
        variables: {
            ...variables,
            limit,
            offset
        },
        fetchPolicy: "network-only"
    });

    return data.batches;
};

export const fetchBatchPhotoCounts = async (
    batchIds,
    showOnlySuspendedCreators
) => {
    const { data } = await apolloClient.query({
        query: FETCH_PHOTO_COUNTS_FOR_BATCHES,
        variables: {
            batchIds,
            showOnlySuspendedCreators
        },
        fetchPolicy: "network-only"
    });

    return data.counts;
};

export const fetchUploadIds = async batchIds => {
    const { data } = await apolloClient.query({
        query: FETCH_UPLOADS_IDS_IN_BATCHES,
        variables: {
            batchIds
        },
        fetchPolicy: "network-only"
    });

    return data.list;
};

/*---------------------------
| Mutations
---------------------------*/
export const assignBatchToMod = async variables => {
    const assignBatchToModResp = await apolloClient.mutate({
        mutation: ASSIGN_BATCH_TO_MOD,
        variables
    });

    return assignBatchToModResp.data;
};
